import S from "sanctuary";

export const REQUEST_PERISCOPE_DASHBOARD =
  "periscopeDashboard/REQUEST_PERISCOPE_DASHBOARD";
export const requestPeriscopeDashboard = () => ({
  type: REQUEST_PERISCOPE_DASHBOARD,
});

export const GET_PERISCOPE_DASHBOARD_FAILED =
  "periscopeDashboard/GET_PERISCOPE_DASHBOARD_FAILED";
export const getPeriscopeDashboardFailed = ({ error }) => ({
  type: GET_PERISCOPE_DASHBOARD_FAILED,
  error: true,
  payload: error,
});

export const GET_PERISCOPE_DASHBOARD_SUCCEEDED =
  "periscopeDashboard/GET_PERISCOPE_DASHBOARD_SUCCEEDED";
export const getPeriscopeDashboardSucceeded = ({ url }) => ({
  type: GET_PERISCOPE_DASHBOARD_SUCCEEDED,
  payload: {
    url,
  },
});

export const PERISCOPE_DATA_SUCCESS = "periscopeDashboard/PERISCOPE_DATA_SUCCESS";
export const periscopeDataRequestSuccess = () => ({
  type: PERISCOPE_DATA_SUCCESS,
});

export const PERISCOPE_DATA_FAILURE = "periscopeDashboard/PERISCOPE_DATA_FAILURE";
export const periscopeDataRequestFailure = () => ({
  type: PERISCOPE_DATA_FAILURE,
});

export const CLEAR_PERISCOPE_STATE = "periscopeDashboard/CLEAR_PERISCOPE_STATE";
export const clearPeriscopeState = () => ({
  type: CLEAR_PERISCOPE_STATE,
});

const INITIAL_STATE = {
  url: S.Nothing,
  dashboardRequestPending: false,
  dasboardRequestError: S.Nothing,
  periscopeDataPending: false,
  periscopeDataSuccess: false,
  periscopeDataFailure: false,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_PERISCOPE_DASHBOARD:
      return {
        ...state,
        dashboardRequestPending: true,
        dashboardRequestError: S.Nothing,
        periscopeDataPending: true,
        periscopeDataSuccess: false,
        periscopeDataFailure: false,
      };
    case GET_PERISCOPE_DASHBOARD_SUCCEEDED:
      return {
        ...state,
        dashboardRequestPending: false,
        dashboardRequestError: S.Nothing,
        url: payload.url,
      };
    case GET_PERISCOPE_DASHBOARD_FAILED:
      return {
        ...state,
        dashboardRequestPending: false,
        dashboardRequestError: S.Just(payload),
      };
    case PERISCOPE_DATA_SUCCESS:
      return {
        ...state,
        periscopeDataPending: false,
        periscopeDataSuccess: true,
      };
    case PERISCOPE_DATA_FAILURE:
      return {
        ...state,
        periscopeDataPending: false,
        periscopeDataFailure: true,
      };
    case CLEAR_PERISCOPE_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

const getState = (state) => state.periscopeDashboard;
export const getDashboardUrl = (state) => getState(state).url;
export const getPeriscopeDataPending = (state) =>
  getState(state).periscopeDataPending;
export const getPeriscopeDataSuccess = (state) =>
  getState(state).periscopeDataSuccess;
export const getPeriscopeDataFailure = (state) =>
  getState(state).periscopeDataFailure;
export default reducer;
